var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAppleIconMono = function SvgAppleIconMono(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M14.46 6.55c.58-.67.97-1.61.87-2.55a3.8 3.8 0 0 0-2.46 1.21 3.3 3.3 0 0 0-.9 2.48c.95.07 1.9-.46 2.49-1.14m2.1 5.95c.02 2.42 2.22 3.23 2.24 3.24-.02.05-.35 1.15-1.16 2.27-.7.98-1.41 1.95-2.55 1.97-1.12.02-1.48-.64-2.76-.64s-1.68.62-2.74.66c-1.1.04-1.93-1.06-2.63-2.03C5.52 16 4.43 12.36 5.9 9.91a4.1 4.1 0 0 1 3.46-2c1.07-.02 2.1.7 2.75.7.66 0 1.9-.87 3.2-.74.54.02 2.07.2 3.05 1.59-.08.04-1.82 1.02-1.8 3.04",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAppleIconMono);
export default ForwardRef;